import { IProduct, SpecialProductType } from "@snackpass/snackpass-types";

export const isDigitalGiftCard = (product: IProduct | undefined) => {
    return product?.specialProductType === SpecialProductType.DigitalGiftCard;
};
